module.exports = __webpack_public_path__ + "img/img_bagsize_nobelt.5950de4c.png";